var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwoosh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 33,
    viewBox: "0 0 94 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00392048 22.234C0.147973 21.3826 0.249525 20.5219 0.444744 19.6814C1.19256 16.4658 2.64882 13.5552 4.45931 10.8096C6.47526 7.75271 8.85488 4.9791 11.3077 2.2662C12.0059 1.49575 12.712 0.731535 13.4795 0L13.1764 0.529969C11.8965 2.77204 10.8779 5.11684 10.3505 7.64764C9.92465 9.69127 9.81758 11.7458 10.5733 13.7342C11.6863 16.6626 13.8888 18.3343 16.9785 18.893C19.4699 19.3436 21.951 19.1491 24.3921 18.6035C26.9307 18.037 29.4425 17.3545 31.9591 16.6953C41.3317 14.2413 50.7025 11.7816 60.0714 9.31618C68.746 7.03753 77.4203 4.75809 86.0944 2.47788L93.7953 0.454483C93.8286 0.442512 93.864 0.437646 93.8993 0.440195C93.9346 0.442744 93.9689 0.452644 94 0.469265L92.9845 0.898848C72.633 9.51124 52.2807 18.1198 31.9276 26.7244C28.6924 28.0917 25.4476 29.4404 22.1722 30.7097C19.405 31.7931 16.5052 32.5103 13.548 32.8428C10.9842 33.1237 8.42745 33.1019 6.00375 32.0957C2.5465 30.6606 0.506139 28.1182 0.066898 24.3912C0.0513376 24.3175 0.0289513 24.2453 0 24.1757L0.00392048 22.234Z",
    fill: "#404040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwoosh);
export default __webpack_public_path__ + "static/media/swoosh.655921da.svg";
export { ForwardRef as ReactComponent };